import React from 'react';
import { Route, Switch } from 'react-router-dom';

import agentMap, { List } from './List';
import { AddEditAgent } from './AddEditAgent';
import { ViewAtt } from '../attorneys/ViewAtt';

function Agents({ match }) {
    const { path } = match;

    return (
        <Switch>
            <Route exact path={path} component={List} />
            <Route path="/agencies/add" component={AddEditAgent} />
            <Route path={`${path}/edit/:id`} component={AddEditAgent} />
            <Route path={`${path}/view/:id`} component={ViewAtt} />
        </Switch>
    );
}

export { Agents };